import { Box, Divider, OSKIcon, OSKThemeType, Typography } from 'oskcomponents';
import React, { useEffect } from 'react';

import { noop, useProfileMetadata } from 'oskcore';
import { connect, useDispatch } from 'react-redux';
import CatalogOrders from './CatalogOrders';
import {
    fetchOrdersAsync,
    resetOrderData,
    selectOrdersByPage,
    setActiveOrderId,
    setOrderNetworkError,
    setOrdersUserFilter,
    SigmaOrder,
} from '~/redux/modules/data/orders';
import { RootState } from '~/redux/store';
import OrderPaginator from './CatalogOrders/paginator';
import { clearDataResourceProvider } from '~/redux';
import { useTheme } from 'styled-components';
import { getProgramId } from '~/utils';

export type OrderListPanelProps = {
    /** The first order in redux, used for setting the default selection */
    firstOrder?: SigmaOrder;
    /** Whether or not orders are loading */
    isLoading?: boolean;
    /** The current 'requested by' user filter for orders  */
    ordersUserFilter?: number;
};

const OrderListPanel = ({ firstOrder, isLoading, ordersUserFilter }: OrderListPanelProps) => {
    const dispatch = useDispatch();
    const [profile] = useProfileMetadata();
    const theme = useTheme() as OSKThemeType;

    useEffect(() => {
        // Select the first order
        if (firstOrder && !isLoading) {
            dispatch(setActiveOrderId(firstOrder.id));
        }
    }, [dispatch, firstOrder, isLoading]);

    return (
        <Box col style={{ height: '100%' }} p={14}>
            <Typography variant="heading2" style={{ padding: '0px 14px', marginBottom: '8px' }}>
                Internal Order Dashboard
            </Typography>

            <Box center="vertical">
                <Box
                    center="all"
                    style={{
                        justifyContent: 'space-between',
                        padding: '8px',
                        width: '95px',
                        marginLeft: '8px',
                        backgroundColor: ordersUserFilter ? theme.colors.blue1 : theme.colors.transparent,
                        color: ordersUserFilter ? theme.colors.white : theme.colors.black900,
                        borderRadius: '5px',
                    }}
                    onClick={() => {
                        const programId = getProgramId();
                        dispatch(resetOrderData());

                        if (ordersUserFilter) {
                            dispatch<any>(fetchOrdersAsync(programId, 0));
                            dispatch(setOrdersUserFilter());
                        } else {
                            clearDataResourceProvider();
                            dispatch(setOrdersUserFilter(profile.id));
                        }
                    }}
                >
                    <OSKIcon
                        code="user"
                        fill={ordersUserFilter ? theme.colors.white : theme.colors.black900}
                        style={{ paddingRight: '4px' }}
                    />
                    <Typography variant="body3">My Tasks</Typography>
                </Box>

                <Box
                    center="all"
                    style={{
                        justifyContent: 'space-between',
                        padding: '8px',
                        width: '90px',
                        marginLeft: '8px',
                    }}
                    onClick={() => {
                        const programId = getProgramId();

                        // Refresh orders
                        dispatch(setOrderNetworkError(false));
                        dispatch(resetOrderData());
                        dispatch<any>(fetchOrdersAsync(programId, 0));
                    }}
                >
                    <OSKIcon fill={theme.colors.black900} code="refresh" />
                    <Typography variant="body3">Refresh</Typography>
                </Box>
            </Box>

            <Divider vm={14} />

            <CatalogOrders />

            {firstOrder && (
                <OrderPaginator
                    inverted
                    style={{
                        borderRadius: '0px',
                        margin: '0px -14px -14px -14px',
                        padding: '14px',
                        boxShadow: '-6px -2px 7px -1px #09080833',
                    }}
                />
            )}
        </Box>
    );
};

const mapStateToProps = (state: RootState) => {
    const firstOrder = (selectOrdersByPage(state, 0) ?? [])?.[0];
    const { loadingOrders, ordersUserFilter } = state.data.orders;

    return {
        firstOrder,
        isLoading: loadingOrders,
        ordersUserFilter: ordersUserFilter,
    };
};

export default connect(mapStateToProps, noop)(OrderListPanel);
